export default __webpack_public_path__ + "locales/pt/Ldap.json?hash=e0f0537d2e70d3c7ccd99a81f7b846d8";